module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('search-results', {
    attrs: {
      "searchTerm": _vm.searchTerm,
      "searchResults": _vm.searchResults,
      "searchCount": _vm.searchCount,
      "searching": _vm.searching,
      "searchFields": _vm.searchFields
    },
    on: {
      "onSimpleSearch": function($event) {
        return _vm.handleSimpleSearch($event)
      },
      "onAdvancedSearch": function($event) {
        return _vm.handleAdvancedSearch($event)
      },
      "exportToFile": _vm.exportToFile
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cadf7aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/containers/interaction/InteractionSearchContainer.vue
// module id = 3136
// module chunks = 3